<div class="app-header" [ngClass]="{ 'app-header-list': isListPayformsVisible$ | async }" fxLayout="column" fxLayoutAlign="center stretch">
  <xpo-utils-region-banner [showRegion]="true"></xpo-utils-region-banner>
  <div [ngClass]="{ 'app-header-top-non-list': (isListPayformsVisible$ | async) === false, 'app-header-top-list': isListPayformsVisible$ | async }" fxLayout="row" fxLayoutAlign="center center">
    <div class="app-header-content" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="app-header-content-left" fxLayout="row" fxLayoutAlign="start center">
        <div class="app-header-content-left__app-title">Edge</div>
        <div class="app-header-content-left__app-sub-title">{{ appName }}</div>
      </div>
      <div class="app-header-content-right" fxLayout="row" fxLayoutAlign="end center">
        <div>
          <button mat-button *ngIf="isListPayformsVisible$ | async" color="primary" (click)="listPayformsClicked()" class="app-header-content-right-allpayforms">
            <mat-icon>list_alt</mat-icon><span class="app-header-content-right-allpayforms-label">Payforms</span>
          </button>
        </div>
        <button mat-button mat-icon-button arial-label="Feedback" tabindex="-1" (click)="feedbackClicked()" matTooltip="Feedback">
          <mat-icon class="app-header-content-right-feedback-icon">feedback</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div #navBar>
    <div class="app-header-nav-bar" *ngIf="isListPayformsVisible$ | async"></div>
  </div>
</div>
